import log from 'loglevel';

/** URLs für Identitätsstiftende Fachverfahren einer Umgebung */
export interface ProfileSelectionRedirectUrls {
  profilanlage: {
    [key: string]: string;
  };
  baidmatch: {
    [key: string]: string;
  };
  freischaltung: string;
  profilonline: string;
}

export class Config {
  authority: string = '';
  logLevel?: log.LogLevelNames = 'info';
  extraQueryParams?: any = {};
  metadataUrl = '';
  devmode?: boolean = true;
  deprecatedExpireEvents?: boolean = true;
  profileSelectionRedirectUrls: {
    default: ProfileSelectionRedirectUrls;
    [key: string]: Partial<ProfileSelectionRedirectUrls>;
  };
  constructor() {}
}
